import { AxiosError } from "axios";
import { useMutation } from "react-query";
import ApiError from "types/ApiError";
import Product from "types/Product";
import { authInstance } from "apis";

interface DTO {
  file?: string;
  keyword?: string;
  categoryIds?: number[];
  origin?: string;
  // resistPrinting?: string;
  locationId?: number;
  purposeId?: number;
  minPrice?: number;
  maxPrice?: number;
}

interface Params {
  searchDto: DTO;
  onSuccess: () => void;
}

interface Data {
  products: Product[];
}

const useSearchProduct = ({ searchDto, onSuccess }: Params) => {
  const fetcher = async () => {
    const { data, config } = await authInstance.post(
      "product/search",
      searchDto
    );
    console.log("config", config);
    return data;
  };

  const { mutate, data, isError } = useMutation<Data, AxiosError<ApiError>>(
    fetcher,
    {
      onSuccess: () => {
        onSuccess();
      },
    }
  );

  return { products: data?.products, isError, mutate };
};

export default useSearchProduct;
